var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { nip19, nip44 } from "nostr-tools";
import { decodeNKeys } from "./nkeys.js";
import { hexToBytes } from "@noble/hashes/utils.js";
import { pool } from "../pool.js";
const defaultRelays = [
    "wss://relay.damus.io/",
    "wss://relay.primal.net/",
    "wss://nos.lol",
    "wss://relay.nostr.wirednet.jp/",
    "wss://nostr-01.yakihonne.com",
    "wss://relay.snort.social",
    "wss://relay.nostr.band",
    "wss://nostr21.com",
];
export const getDefaultRelays = () => {
    return defaultRelays;
};
const decryptFormEvent = (event, nkeys) => {
    if (!nkeys)
        return null;
    const { viewKey } = decodeNKeys(nkeys);
    if (!viewKey)
        return null;
    const conversationKey = nip44.v2.utils.getConversationKey(hexToBytes(viewKey), event.pubkey);
    return nip44.v2.decrypt(event.content, conversationKey);
};
// Cache promises keyed by "naddr:nkeys" — deduplicates in-flight requests and
// avoids re-fetching the same form on every React remount or split-mode keystroke.
// Failed promises are evicted so the next attempt can retry.
const formCache = new Map();
export const fetchFormTemplate = (naddr, nkeys) => {
    const cacheKey = `${naddr}:${nkeys !== null && nkeys !== void 0 ? nkeys : ""}`;
    const cached = formCache.get(cacheKey);
    if (cached)
        return cached;
    const promise = _doFetch(naddr, nkeys);
    formCache.set(cacheKey, promise);
    promise.catch(() => formCache.delete(cacheKey));
    return promise;
};
const _doFetch = (naddr, nkeys) => __awaiter(void 0, void 0, void 0, function* () {
    const { pubkey, kind, identifier, relays } = nip19.decode(naddr)
        .data;
    let formIdPubkey = pubkey;
    let relayList = (relays === null || relays === void 0 ? void 0 : relays.length) ? relays : getDefaultRelays();
    const filter = {
        kinds: [30168],
        authors: [formIdPubkey],
        "#d": [identifier],
    };
    const nostrEvent = yield pool.get(relayList, filter);
    if (!nostrEvent)
        throw Error(`Event not found on given relays: ${JSON.stringify(relayList)}`);
    if ((nostrEvent === null || nostrEvent === void 0 ? void 0 : nostrEvent.content) === "") {
        const returnTags = [...nostrEvent.tags, ["pubkey", nostrEvent.pubkey]];
        return returnTags;
    }
    const decryptedEvent = decryptFormEvent(nostrEvent, nkeys);
    const relayTags = nostrEvent.tags.filter((t) => t[0] === "relay");
    const dTag = nostrEvent.tags.find((t) => t[0] === "d");
    if (!decryptedEvent)
        throw Error(`Could not decrypt form with supplied keys: ${nkeys}`);
    let decryptedTags;
    try {
        decryptedTags = JSON.parse(decryptedEvent);
    }
    catch (_a) {
        throw Error("Malformed Form Event, could not parse");
    }
    if (dTag)
        decryptedTags.push(dTag);
    decryptedTags.push(...relayTags, ["pubkey", nostrEvent.pubkey]);
    return decryptedTags;
});
